interface Props {
  size?: 'sm' | 'md' | 'lg'
  label?: string
}

export function Spinner({ size = 'md', label = 'Carregando...' }: Props) {
  return (
    <span className={`cf-spinner cf-spinner--${size}`} role='status'>
      <span className='cf-sr-only'>{label}</span>
    </span>
  )
}
